<script lang="ts">
    import type {RecordSearchParams} from 'typings/portaro.be.types';
    import type {CalendarDate} from 'shared/components/kp-calendar/types';
    import {calendarDateFromLuxon, luxonDateFromCalendarDate} from 'shared/components/kp-calendar/utils';
    import {getSutorReportsOptimisationContext} from '../sutor-reports-optimisation-context';
    import {DateTime} from 'luxon';
    import {exists} from 'shared/utils/custom-utils';
    import {Kind, SearchType} from 'shared/constants/portaro.constants';
    import {SUTOR_REPORTS_OPTIMISATION_SETTINGS} from 'src/features/sutor/sutor-constants';
    import KpPageableSearchResults from '../../../../../../search/kp-search-results/KpPageableSearchResults.svelte';
    import KpBarebonesTable from 'shared/ui-widgets/table/barebones/KpBarebonesTable.svelte';
    import ReportOptimisationUserItem from './ReportOptimisationUserItem.svelte';
    import KpSearchContext from 'src/features/search/kp-search-context/KpSearchContext.svelte';
    import ErpRowCalendar from 'src/features/erp/components/erp-row-calendar/ErpRowCalendar.svelte';
    import KpFlexColumn from 'shared/layouts/flex/KpFlexColumn.svelte';

    const context = getSutorReportsOptimisationContext();

    let currentDate: DateTime | null = null;

    function createUsersListStaticParams(date: DateTime): RecordSearchParams {
        return {
            qt: `{"and": [{"not": {"field": "recordRelatedRecord", "eq": {"value": "${context.projectRecord.id}"}}}, {"field": "reportDate", "eq": {"value": "${date.toISODate()}"}}]}`,
            kind: [Kind.KIND_RECORD],
            type: SearchType.TYPE_TABLE,
            rootFond: [{id: SUTOR_REPORTS_OPTIMISATION_SETTINGS.userListFond}],
            pageSize: 100
        };
    }

    const handleDateSelected = (event: CustomEvent<CalendarDate>) => {
        currentDate = luxonDateFromCalendarDate(event.detail);
    };
</script>

<KpFlexColumn fillSize gap="xxl">
    <ErpRowCalendar startDate="{calendarDateFromLuxon(DateTime.now())}"
                    selectedDate="{exists(currentDate) ? calendarDateFromLuxon(currentDate) : null}"
                    on:date-selected={handleDateSelected}/>

    {#if !exists(currentDate)}
        <span class="text-center">Nejdříve vyberte datum</span>
    {/if}

    {#if exists(currentDate)}
        {#key currentDate}
            <KpSearchContext staticParams="{createUsersListStaticParams(currentDate)}" let:searchManager>
                <KpPageableSearchResults pagination="{searchManager.getPagination()}" let:paginationData>
                    <KpBarebonesTable fontSize="12px">
                        <tr slot="header">
                            <th>Pracovník</th>
                            <th>Zakázka</th>
                            <th>Datum</th>
                            <th>Vhodný k optimalizaci</th>
                        </tr>

                        <svelte:fragment slot="body">
                            {#each paginationData.items as record(record.id)}
                                <ReportOptimisationUserItem {record}/>
                            {/each}
                        </svelte:fragment>
                    </KpBarebonesTable>
                </KpPageableSearchResults>
            </KpSearchContext>
        {/key}
    {/if}
</KpFlexColumn>